import { render, staticRenderFns } from "./MatchProoveScore.vue?vue&type=template&id=82855b7e&scoped=true&"
import script from "./MatchProoveScore.vue?vue&type=script&lang=js&"
export * from "./MatchProoveScore.vue?vue&type=script&lang=js&"
import style0 from "./MatchProoveScore.vue?vue&type=style&index=0&id=82855b7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82855b7e",
  null
  
)

export default component.exports